import { combineReducers } from 'redux';

import auth, { AuthReducer } from './auth';
import qb, { QBReducer } from './qb';
import notification, { NotificationReducer } from './notification';
import call, { CallReducer } from './call';

export type StoreState = {
  auth: AuthReducer;
  call: CallReducer;
  notification: NotificationReducer;
  qb: QBReducer;
};

export default combineReducers({
  auth,
  call,
  notification,
  qb,
});
